import { PhasrRestrictedProfilesListWebComponent } from './component/PhasrRestrictedProfilesListWebComponent';

export { PhasrRestrictedProfilesListWebComponent };
